// extracted by mini-css-extract-plugin
export default {"user-level":"UserLevel_user-level__mRvn8","bold-text":"UserLevel_bold-text__QyYLe"};